module.exports = __webpack_public_path__ + "img/图片30.8da06093.png";